import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import CalendarPage from "@/pages/CalendarPage";
import MyActivities from "@/pages/MyActivities";
import PublicActivity from "@/pages/PublicActivity";
import Contacts from "@/pages/Contacts";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8]">
                <div className="text-[#666664] text-sm tracking-[0.1em] uppercase" data-testid="loading-indicator">Loading</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function AppRouter() {
    const location = useLocation();
    // Synchronously detect session_id in URL fragment and route to AuthCallback
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/public/:id" element={<PublicActivity />} />
            <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
            <Route path="/my" element={<ProtectedRoute><MyActivities /></ProtectedRoute>} />
            <Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/calendar" replace />} />
            <Route path="*" element={<Navigate to="/calendar" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                    <Toaster position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
